import React, { useState, useContext, useEffect } from "react";
import style from "./PropertiesLayout.module.css";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Properties from "../../IFormDesignerLayout/IFormDesignerComponents/Properties.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronCircleRight,
  faChevronCircleLeft,
  faThumbtack,
} from "@fortawesome/free-solid-svg-icons";
import IconButton from "@material-ui/core/IconButton";
// import {AppContext} from '../../../Resources/CanvasContextFile';
import { useTranslation } from "react-i18next";
import { useDispatch, addContexts, useSelector } from "../../../Redux";
import Tooltip from "@material-ui/core/Tooltip";
import { GetState, GetStateFromData } from "../../CustomHooks/CustomHooks.js";
// import useFocusTrap from '../../../useFocusTrap.js';

function checkForElemTypeAndSetSelectedControl(
  prev_json,
  curr_json,
  setCurrControl,
  setSelectedControl
) {
  //  console.log("selectedControl prev_json", prev_json, "curr_json", curr_json);

  if (
    curr_json?.elem_type !== "" &&
    curr_json?.elem_type !== undefined &&
    curr_json?.elem_type !== null
  ) {
    setCurrControl(curr_json);
    // setSelectedControl(curr_json);
  } else {
  }
  // setCurrControl();
}

const PropertiesLayout = (props) => {
  const contexts = GetStateFromData(props.containerId);

  // const trapRef = useFocusTrap();

  const {
    updateJson,
    propertyPinned,
    setPropertyPinned,
    toggleProperty,
    setToggleProperty,
    openProperties,
    setOpenProperties,
    setSelectedControl,
    selectedControl,
  } = contexts.contexts;
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState } =
    updateJson;
  const {addColumnOpen} = GetState("addColumnOpen");
  const isIPadOrIPhone = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.userAgent.includes("Macintosh") && "ontouchend" in document);
  const addColumnBackdropOpen = isIPadOrIPhone ? addColumnOpen : false
  // const AppContextVar = useContext(AppContext);

  // let openProperties;
  // let setOpenProperties;
  // let propertyPinned;
  // let setPropertyPinned;
  // let toggleProperty;
  // let setToggleProperty;
  // if(AppContextVar){
  //   propertyPinned = AppContextVar.propertyPinned;
  //   setPropertyPinned = AppContextVar.setPropertyPinned;
  //   openProperties = AppContextVar.openProperties;
  //   setOpenProperties = AppContextVar.setOpenProperties;
  //   toggleProperty = AppContextVar.toggleProperty;
  //   setToggleProperty = AppContextVar.setToggleProperty;
  // }

  const { t } = useTranslation(["styles", "translation"]);

  // const [openProperties, setOpenProperties] = React.useState(false);
  const [variant, setVariant] = useState("temporary");
  const [control, setControl] = useState({});

  // useEffect(()=>{
  //     console.log(
  //       "Property drawer openProperties changed! :: ",
  //       openProperties,
  //       props.selectedControl
  //     );
  // },[openProperties]);

  useEffect(() => {
    checkForElemTypeAndSetSelectedControl(
      control,
      props.selectedControl,
      setControl,
      setSelectedControl
    );

    // setControl(selectedControl)
  }, [props.selectedControl]);

  const anchor = "right";

  const useStyles = makeStyles({
    overrides: {
      MuiDrawer: {
        maxWidth: "265px",
      },
    },
    root: {
      boxShadow: "0px 3px 6px #00000029",
      "& > div": {
        position: "absolute",
        zIndex: "2",
      },
      "& .MuiDrawer-paperAnchorRight": {
        //  left: window?.psh_configs?.selectedLanguage==="ar" ? "0" : "auto",
        //  right: window?.psh_configs?.selectedLanguage==="ar" ? "auto" : "right",
        right: t("styles:leftValN"),
        left: t("styles:rightValN"),
        height: "calc(100% - 40px)",
        top: "40px",
      },
    },
    paper: {
      // backgroundColor: "red",
      zIndex: 1,
      overflow: "hidden",
    },
    tooltip: {
      maxWidth: "260px",
      // maxHeight: "96px",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      color: "black",
      border: "#70707075 1px solid",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
      fontSize: 12,
    },
    arrow: {
      "&:before": {
        border: "1px solid #70707075",
      },
      color: "white",
      fontSize: 15,
    },
    iconStyleArrow: {
      "& .MuiIconButton-label": {
        paddingRight: "0 !important",
      },
    },
  });

  const classes = useStyles();

  const translationStyles1 = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  
  // const [paneOpened, setPaneOpened] = useState(false);

  const togglePinning = () => {
    if (openProperties) {
      // setPropertyPinned(!propertyPinned);
      setPropertyPinned(!propertyPinned);
      // setPaneOpened(true);
    } else {
      // alert('Select any option and then try pinning!');
      setOpenProperties(true);
      // setPaneOpened(false);
    }
  };

  var pinBtnConditionalStyle = {};
  var pinIconStyle = {};

  var propertiesToRender;
  try {
    // console.log('BEFORE_CODE_BURST::selectedControl',props.selectedControl);
    // if(props.selectedControl?.elem_type){
    propertiesToRender = (
      <Properties
        containerId={props.containerId}
        formData={props.formData}
        subformState={props.subformState}
        selectedControl={control}
        themeJSONData={props.themeJSONData}
        openProperties={props.openProperties}
        setOpenProperties={setOpenProperties}
        propertyPinned={propertyPinned}
        hideProperties={props.hideProperties}
        applyChanges={(ev, saveOldState) =>
          props.applyChanges(ev, saveOldState)
        }
        changeUndoList={() => props.changeUndoList()}
        microFrontendData={props.microFrontendData}
      />
    );
    // }
  } catch (e) {
    console.log("HERE===>", e);
  }
  // changeLeftNavigationHeader={props.changeLeftNavigationHeader}
  //console.log('props.selectedControl :: ',props.selectedControl);

  // var maxWidth = 280;
  var maxWidth = 300;
  var pinIconSize = 20;
  var pinIconStyle = {
    fontSize: pinIconSize + "px",
    color: propertyPinned ? "#0072C6" : "#F2F8FC",
    backgroundColor: propertyPinned ? "#FFFFFF" : "rgba(0,0,0,0.3)",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    borderRadius: "50%",
    border: propertyPinned ? "1px solid #0072C6" : "1px solid #F2F8FC",
    padding: "1px",
    // marginRight : "90%"
  };
  var pinBtnConditionalStyle = {
    transition: "width 0.25s ease-in-out",
    // right:openProperties?(maxWidth+(pinIconSize/2))+'px':(68-(pinIconSize/2))+'px'
    //  right:openProperties?maxWidth+'px':'0px',
    right: openProperties ? (props?.microFrontendData?.taskId ? t("315px") : t("280px")) : t("0px"),
   left: translationStyles1
  ? openProperties
    ? props?.microFrontendData?.taskId
      ? t("315px")
      : t("280px")
    : t("auto")
  : t("auto"),
    direction: translationStyles1 ? "ltr" : "rtl",
    top: "50vh",
    opacity: addColumnBackdropOpen ? "0" : "1"
  };
  var conditionalDrawerStyling = {
    // display:(openProperties===true)?'block':'none',
    transition: "width 0.25s ease-in-out",
    width: openProperties ? maxWidth + "px" : "0px",
    height: "100%"
  };
  // const [conditionalDrawerStyling, setConditionalDrawerStyling] = useState({display:(openProperties===true)?'block':'none',transition: 'width 1s ease-in-out 1s',width:openProperties?'100%':'0px'});

  const toggleDrawer = (anchor, open) => (event) => {
    //  console.log("toggleProperty :: toggleDrawer() anchor :: ", anchor, "open :: ", open, "event :: ", event);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    //console.log('setting open : ',open);
    //console.log('setting open : ',openProperties);
    //console.log('conditionalDrawerStylingJson :: ',conditionalDrawerStyling);
    // setOpenProperties(open);
    //console.log('here::props.selectedControl::',props.selectedControl);
    if (
      props.selectedControl !== null &&
      props.selectedControl !== undefined &&
      props.selectedControl !== "" &&
      props.selectedControl.elem_type !== null &&
      props.selectedControl.elem_type !== undefined &&
      props.selectedControl.elem_type !== ""
    ) {
      setOpenProperties(true);
    } else {
      // alert('Select any control first in order to open the properties.');
      // <CustomizedAlert
      // open={true}
      // alertType='info'
      // alertMsg={'Select any control first in order to open the properties.'}
      // />
    }
    // conditionalDrawerStyling['width']=maxWidth+'px';
    //console.log('setting open : ',open);
    //console.log('setting open : ',openProperties);
  };

  useEffect(() => {
    if (toggleProperty) {
      if (
        props.selectedControl !== null &&
        props.selectedControl !== undefined &&
        props.selectedControl !== "" &&
        props.selectedControl.elem_type !== null &&
        props.selectedControl.elem_type !== undefined &&
        props.selectedControl.elem_type !== ""
      ) {
        if (openProperties === true && !toggleProperty) {
          setOpenProperties(false);
        } else {
          setOpenProperties(true);
        }
      } else {
        setOpenProperties(false);
        // alert("Select any control to show the property!");
      }
    }
  }, [toggleProperty]);

  const handleClickAway = () => {
    setOpenProperties(false);
    // conditionalDrawerStyling['width']='0px';
    // var conditionalDrawerStylingJson = conditionalDrawerStyling;
    // conditionalDrawerStylingJson['width']='0px';
    // setConditionalDrawerStyling(conditionalDrawerStylingJson);
    //console.log('handleClickAway PropertiesLayout');
  };

  return (
    // < div 
    //     // ref={trapRef}
    //   >
        // <div
        //   tabIndex="0"
        // >
        <Drawer
        tabIndex="0"
        // ref={trapRef}
        anchor={anchor}
        open={openProperties}
        onClose={toggleDrawer(anchor, false)}
        //classes={{modal: styles.modal , root: styles.root}}
        //   className={style.conditionalDrawerStyling + " " + classes.root}
        classes={{
          root: classes.root,
          paper: classes.paper,
        }}
        className="formBuilder_main_app"
        // style={conditionalDrawerStyling}
        // variant={variant}
        variant={"permanent"}
      >
        {openProperties === true &&
          props.selectedControl &&
          props.selectedControl.elem_type !== "" && (
            <div className={style.pinIconDiv} style={pinBtnConditionalStyle}>
              <Tooltip
                title={
                  !propertyPinned
                    ? t(`translation:${"Pin_Properties"}`)
                    : t(`translation:${"Unpin_Properties"}`)
                }
                classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                placement={"bottom-start"}
                arrow
              >
                <IconButton
                  tabIndex="0"
                  onKeyDown={(e)=>{if(e.key==="Enter"){ togglePinning() }}}
                  onClick={togglePinning}
                  // className={style.pinBtn}
                  className={classes.iconStyleArrow}
                  style={{ paddingRight: "0 !important" }}
                >
                  {
                  !openProperties 
                  ?
                  <FontAwesomeIcon
                    key={"faChevronCircle"}
                    icon={
                      translationStyles1
                        ? faChevronCircleRight
                        : faChevronCircleLeft
                    }
                    style={pinIconStyle}
                  />
                  :
                  [
                  !propertyPinned
                  ?
                  <img
                    src={require("../../../Icons/Pinning_icon.svg").default}
                    height="24"
                    style={{border:"1px solid #c4c4c4", borderRadius:"50px"}}
                    alt="Pin icon"
                  />
                  :
                  <img
                    src={require("../../../Icons/Pinning_blue_icon.svg").default}
                    height="24"
                    style={{border:"1px solid #c4c4c4", borderRadius:"50px"}}
                    alt="Pin icon2"
                  />
                  ]
                  }
                </IconButton>
              </Tooltip>
            </div>
          )}

        {
          <div
          tabIndex="0"
            style={conditionalDrawerStyling}
          >
            {propertiesToRender}
          </div>
        }
        </Drawer>
      // </div>
    // </div>
  );
};

export default PropertiesLayout;
